import styles from './Copyright.module.scss';
/**
 * Displays the copyright string
 *
 * @author    José Nunes <jnunes@dodoc.com>
 * @copyright 2017 doDOC
 */
const Copyright = ({ hero, white }: { hero: boolean; white: boolean }) => (
  <span
    className={`${styles.root} ${hero ? styles.hero : undefined} ${
      white ? styles.white : undefined
    }`}
  >{`© doDOC ${new Date().getFullYear()}`}</span>
);

export default Copyright;
